import React, { useEffect, useState } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem as BaseNavItem,
} from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { startCase, find } from 'lodash';
import styled from 'styled-components';
import { useSession, useFeatures } from '@cordata/buffet';

import {
  authorizedInstance as Authorized,
  adminInstance as Admin,
} from '~/utils';

import Identity from '~/assets/identity.svg';

const StyledPage = styled.div`
  input {
    background-clip: inherit;
    border-color: white;
  }
`;

const NavItem = (r) => {
  const location = useLocation();

  return (
    <BaseNavItem key={r.path} active={location.pathname.includes(r.path)}>
      <Link to={r.path} className="nav-link">
        <FontAwesomeIcon icon={r.icon} fixedWidth size="lg" />
        <span className="d-inline-block d-sm-inline-block d-md-none ml-2">{startCase(r.label)}</span>
      </Link>
    </BaseNavItem>
  );
};

const CordataNavBar = ({ routes }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthed, current } = useSession();
  const { hasAppKickstarter } = useFeatures();
  const features = useFeatures();
  const [division, setDivision] = useState();

  const logout = () => {
    Authorized
      .get('/destinations')
      .then(r => r.data.data)
      .then((r) => {
        console.log(r);

        localStorage.clear();

        const gk = find(r, ['name', 'Gatekeeper']);

        window.location = `${gk.url}/logout`;
      });
  };

  const goBack = () => {
    Authorized
      .get('/destinations')
      .then(r => r.data.data)
      .then((r) => {
        console.log(r);

        const gk = find(r, ['name', 'Gatekeeper']);

        window.location = `${gk.url}/home`;
      });
  };

  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    fetch('/version.json')
      .then(r => r.json())
      .then(r => console.table(r));
  }, []);

  useEffect(() => {
    if (
      current &&
      current.id &&
        current.attributes.currentDivisionUid
    ) {
      Admin
        .get(`/division/${current.attributes.currentDivisionUid}`)
        .then(r => r.data.data)
        .then((r) => {
          setDivision(r);
          localStorage.setItem('div', r.id);
          localStorage.setItem('org', r.attributes.orgUid);
        });
    }
  }, [current]);

  return isAuthed ? (
    <>
      <StyledPage>
        <Navbar color={hasAppKickstarter ? 'secondary' : 'primary'} dark expand="md" className="sticky-top">
          <NavbarBrand tag={Link} to="/home">
            <img src={Identity} width={130} alt="Kickstarter - Cordata" className="mr-2" />
          </NavbarBrand>

          <NavbarToggler onClick={toggle} />

          <Collapse isOpen={isOpen} navbar>
            <Nav className="mr-auto" navbar>
              {hasAppKickstarter && (
                <BaseNavItem className="nav-link" onClick={goBack}>
                  <FontAwesomeIcon icon="chevron-circle-left" fixedWidth size="lg" />
                  <span className="d-inline-block d-sm-inline-block d-md-none ml-2">Back</span>
                </BaseNavItem>
              )}

              {routes.filter(r => r.main).filter((r) => {
                const flag = r.active;

                if (flag) {
                  return Array.isArray(flag)
                    ? flag.some(f => features[f])
                    : features[flag];
                }

                return r;
              }).map(r =>
                <NavItem {...r} />)}
            </Nav>

            <Nav className="ml-auto" navbar>
              {division && (
                <BaseNavItem className="nav-link">
                  <span className="d-inline-block d-md-inline-block mx-2">
                    {division.attributes.divisionName}
                  </span>
                </BaseNavItem>
              )}

              <BaseNavItem className="nav-link" onClick={logout}>
                <FontAwesomeIcon icon="sign-out-alt" fixedWidth size="lg" />
                <span className="d-inline-block d-sm-inline-block d-md-none ml-2">Logout</span>
              </BaseNavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </StyledPage>
    </>
  ) : <div />;
};

CordataNavBar.propTypes = {
  location: PropTypes.shape().isRequired,
  routes: PropTypes.PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default CordataNavBar;
